/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { PaymentMethod } from './paymentMethod';


export interface IndependentCredit { 
    account: Account;
    account_id: string;
    amount: number;
    authorized_at?: string;
    canceled_at?: string;
    /**
     * Time at which the object was created.
     */
    created_at: string;
    currency: IndependentCredit.CurrencyEnum;
    failure_code?: string;
    failure_message?: string;
    id: string;
    metadata?: object;
    payment_method: PaymentMethod;
    payment_method_id: string;
    payment_provider_id: string;
    payment_provider_responses?: object;
    settled_at?: string;
    /**
     * Unique key for linking to this independent credit Key used to identify an independent credit upon creation by another service i.e. External Transactions can create an event with this key and link it to an independent credit that is yet to be created.
     */
    source_idempotency_key?: string;
    source_transaction_id?: string;
    source_type?: IndependentCredit.SourceTypeEnum;
    status: IndependentCredit.StatusEnum;
    /**
     * Time at which the object was last updated.
     */
    updated_at: string;
}
export namespace IndependentCredit {
    export type CurrencyEnum = 'aud' | 'cad' | 'dkk' | 'eur' | 'hkd' | 'jpy' | 'nzd' | 'nok' | 'gbp' | 'zar' | 'sek' | 'chf' | 'usd';
    export const CurrencyEnum = {
        AUD: 'aud' as CurrencyEnum,
        CAD: 'cad' as CurrencyEnum,
        DKK: 'dkk' as CurrencyEnum,
        EUR: 'eur' as CurrencyEnum,
        HKD: 'hkd' as CurrencyEnum,
        JPY: 'jpy' as CurrencyEnum,
        NZD: 'nzd' as CurrencyEnum,
        NOK: 'nok' as CurrencyEnum,
        GBP: 'gbp' as CurrencyEnum,
        ZAR: 'zar' as CurrencyEnum,
        SEK: 'sek' as CurrencyEnum,
        CHF: 'chf' as CurrencyEnum,
        USD: 'usd' as CurrencyEnum
    };
    export type SourceTypeEnum = 'external';
    export const SourceTypeEnum = {
        EXTERNAL: 'external' as SourceTypeEnum
    };
    export type StatusEnum = 'canceled' | 'failed' | 'pending' | 'succeeded';
    export const StatusEnum = {
        CANCELED: 'canceled' as StatusEnum,
        FAILED: 'failed' as StatusEnum,
        PENDING: 'pending' as StatusEnum,
        SUCCEEDED: 'succeeded' as StatusEnum
    };
}


